$(document).ready(function() {
    const mainSwiper = new Swiper('[data-path_slider]', {
        speed: 800,
        slidesPerView: 'auto',

        grabCursor: true,
        slideToClickedSlide: true,

        freeMode: true,
        freeModeMinimumVelocity: 0.05,
        centeredSlides: true,
        freeModeSticky: true,
        freeModeMomentumRatio: .5,

        watchSlidesProgress: true,
        watchSlidesVisibility: true,
    });

    // $('.timeline-point').click(function(event) {
    //     var index = mainSwiper.clickedIndex

    //     mainSwiper.slideTo(index)
    // });

});